import app from 'flarum/forum/app';

export default function getCurrentLanguage() {
  if (!app.initializers.has('fof/discussion-language')) {
    return null;
  } else if (
    app.initializers.has('fof/discussion-language') &&
    app.forum.attribute('support_knowledge_base_enable_language_dropdown') == false &&
    app.forum.attribute('support_knowledge_base_default_language') !== 'auto'
  ) {
    return app.forum.attribute('support_knowledge_base_default_language');
  } else if (m.route.param('any')) {
    return null;
  }
  // Custom override language when dropdown changed
  else if (m.route.param('language')) {
    return m.route.param('language');
  }

  // Return current language
  return app.forum.attribute('support_knowledge_base_default_language') == 'auto'
    ? app.translator.formatter.locale
    : app.forum.attribute('support_knowledge_base_default_language');
}
